module.exports = __webpack_public_path__ + "static/media/interactableGraphicsIcon.684f668c.svg";